export const maxCurrencyValue = 99999999999.99;

export const roundToNearestValue = (value: number): number => {
  let result = 0;
  if (value) {
    const val = parseFloat(Math.floor(value).toString()).toFixed(2);
    result = Number(val);
  }
  return result;
};

export const formatNumber = (value: number, digit = 2): number => {
  return value === null || value === undefined ? null : parseFloat(checkIsNAN(Number(value)).toFixed(digit));
};

export const checkIsNAN = (value: number): number => {
  if (isNaN(value)) {
    return 0;
  } else {
    return value;
  }
};

export const calculateSum = (values: number[]) => values.filter((x) => !!x).reduce((a, b) => a + b, 0);

export const roundToValue = (input: number, value: number): number => {
  const multiple = value;
  return Math.round(input / multiple) * multiple;
};
